
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9.474","height":"12.015"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1863.763 -153.493)","fill":"none","stroke":"#6b7786"}},[_c('path',{attrs:{"d":"M1865.958 162.466h-.424a1.271 1.271 0 01-1.271-1.266v-5.936a1.271 1.271 0 011.271-1.271h4.236a1.271 1.271 0 011.271 1.271v1.187"}}),_c('rect',{attrs:{"width":"6.778","height":"8.473","rx":"1","transform":"translate(1865.959 156.535)"}})])])
          )
        }
      }
    